import { Show } from 'solid-js';
import { Badge } from '~/components/primitives/badge';
import { createClock } from '~/lib/clock';

interface StatusBarProps {
  handle?: string;
  net?: string;
  alerts?: number;
}

/** Top status bar — handle · alert · clock. Lives below the iOS dynamic
 *  island; the safe-area inset is applied via the .safe-top helper class. */
export function StatusBar(props: StatusBarProps) {
  const clock = createClock();
  const handle = () => props.handle ?? 'WRAITH//00';
  const net = () => props.net ?? 'TIER-3';
  const alerts = () => props.alerts ?? 0;

  return (
    <div class="statusbar safe-top">
      <div style={{ display: 'flex', 'align-items': 'center', gap: '6px' }}>
        <span class="t-micro" style={{ color: 'var(--action)' }}>●</span>
        <span
          class="t-mono"
          style={{ 'font-size': '11px', color: 'var(--fg)', 'letter-spacing': '0.06em' }}
        >
          {handle()}
        </span>
        <span class="t-micro">/ {net()}</span>
      </div>
      <div style={{ display: 'flex', 'align-items': 'center', gap: '6px' }}>
        <Show when={alerts() > 0} fallback={<Badge tone="data">NOMINAL</Badge>}>
          <Badge tone="hostile">{alerts()} ALERT</Badge>
        </Show>
      </div>
      <div style={{ 'text-align': 'right' }}>
        <span
          class="t-mono t-tab"
          style={{ 'font-size': '11px', color: 'var(--fg-mute)', 'letter-spacing': '0.06em' }}
        >
          {clock()}
        </span>
        <span class="t-micro" style={{ 'margin-left': '6px' }}>UTC</span>
      </div>
    </div>
  );
}
